// IT · Recorrido de novedades (TourNovedades.vue)
export const tourNovedades = {
  "title": "Novità di WA Checkin",
  "kicker": "Novità",
  "stepOf": "Passo {n} di {total}",
  "close": "Chiudi",
  "dontShow": "Non mostrare più",
  "prev": "Indietro",
  "next": "Avanti",
  "done": "Ho capito",
  "steps": {
    "icons": {
      "title": "Icone sulle tue prenotazioni",
      "text": "Ogni prenotazione del calendario e dell'elenco ora mostra piccole icone: richieste alla Reception IA, chiamate, note e se c'è ancora un importo da incassare. Passaci sopra con il mouse per vedere i dettagli senza aprire la prenotazione.",
      "cta": ""
    },
    "early": {
      "title": "Fai pagare l'arrivo anticipato",
      "text": "L'early check-in ora può avere un prezzo. L'agente IA chiede l'orario di arrivo, calcola il costo e invia il link di pagamento. Una volta pagato, si conferma da solo.",
      "cta": "Configuralo in Agente IA"
    },
    "reception": {
      "title": "Reception IA",
      "text": "Tutto ciò che i tuoi ospiti chiedono all'agente (entrare prima, uscire più tardi, notti in più, fatture, messaggi di chiamata) arriva in un'unica casella. Approvi, rifiuti o dai priorità con un clic e vedi l'importo di ciò che viene addebitato.",
      "cta": "Apri Reception IA"
    },
    "translate": {
      "title": "Traduzione in tempo reale",
      "text": "Nella chat di ogni prenotazione e nella posta in arrivo, attiva la traduzione: ciò che scrive l'ospite ti arriva nella tua lingua e, premendo Invio, vedi prima il tuo messaggio tradotto nella sua lingua prima di inviarlo.",
      "cta": "Vai ai messaggi"
    },
    "voice": {
      "title": "Chiamate con l'agente vocale",
      "text": "Attiva la reception telefonica: l'agente IA risponde alle chiamate nella lingua di chi chiama, risolve i dubbi, invia il link di prenotazione e ti lascia un riepilogo di ogni chiamata.",
      "cta": "Attiva le chiamate"
    }
  },
  "demo": {
    "iconsTipTitle": "Reception IA",
    "iconsTipEarly": "Early check-in",
    "iconsTipPending": "Da pagare:",
    "paid": "Pagata",
    "earlyGuest": "Possiamo entrare alle 11:00?",
    "earlyAgent": "Sì! L'ingresso alle 11:00 costa 30 €. Puoi pagare qui:",
    "earlyPaid": "Pagata · confermata",
    "rx": {
      "early": "Early check-in",
      "late": "Late checkout",
      "extend": "Prolunga soggiorno"
    },
    "pending": "In attesa",
    "confirmed": "Confermata",
    "trGuestOrig": "What time can we pick up the keys?",
    "trGuestMine": "A che ora possiamo ritirare le chiavi?",
    "trMine": "Dalle 15:00, vi aspettiamo",
    "trTheirs": "From 3 pm, we look forward to seeing you",
    "voiceSummaryTitle": "Riepilogo della chiamata",
    "voiceSummary": "Ha chiesto del parcheggio e ha prenotato 2 notti. Link di prenotazione inviato su WhatsApp."
  }
};
